// Router paths
export const CONTACT_SCREEN = 'contact'
export const HOME_SCREEN = 'member-info'
export const REGISTER_SCREEN = '/'     // '/register'
export const REGISTRATION_SUCCESS = 'member-info/payment/register-success'
export const POLICY_SCREEN = 'member-info/policy'
export const PAYMENT_SCREEN = 'member-info/payment'
export const SELECTION_SCREEN = 'member-info/selection'

export const ERROR_SCREEN = 'error'